import { render, staticRenderFns } from "./UserInfoListItem.vue?vue&type=template&id=3a542b34&scoped=true&"
import script from "./UserInfoListItem.vue?vue&type=script&lang=ts&"
export * from "./UserInfoListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a542b34",
  null
  
)

export default component.exports